// extracted by mini-css-extract-plugin
module.exports = {"social__container":"GoogleSignIn_social__container__AkHFV","social__button":"GoogleSignIn_social__button__1tO7n","social":"GoogleSignIn_social__37kJJ"};